import { useForm } from "react-hook-form";
import { LightRoutingLink, PrimaryButton } from "../../../../components/buttons/buttons";
import PasswordControl from "../../../../components/controls/password-control/password-control";
import useOnce from "../../../../hooks/use-once";
import { ActionHandler } from "../../../../types";

export type FormaCambiarClave = {
	claveActual: string;
	nuevaClave: string;
	confirmacionNuevaClave: string;
};

type CambiarClaveFormProps = { loading?: boolean; onAccept: ActionHandler<FormaCambiarClave>; };

const CambiarClaveForm = ({ loading, onAccept }: CambiarClaveFormProps) => {
	const methods = useForm<FormaCambiarClave>();

	useOnce(() => {
		methods.setFocus("claveActual");
	});

	return (
		<form className="mb-3 mt-md-4">
			<div className="card-login-title">
				<div className="row col-12">
					<span className="text-uppercase">Cambio de contraseña</span>
				</div>
			</div>
			<div className="mb-3">
				<PasswordControl
					name="claveActual"
					label="Contraseña actual"
					maxLength={25}
					formMethods={methods}
					pattern={{
						message: "Sólo permite letras, números y algunos caracteres especiales ( @ # $ % & ! * )",
						value: /^([A-Z0-9@#$%&!*]{12,25})$/i
					}}
					minLength={{
						message: "La longitud debe ser entre 12 y 25 caracteres",
						value: 12
					}}
					required
				/>
			</div>
			<div className="mb-3">
				<PasswordControl
					name="nuevaClave"
					label="Nueva contraseña"
					maxLength={25}
					formMethods={methods}
					pattern={{
						message: "Debe contener al menos un número, una letra mayúscula, una letra minúscula y un carácter especial ( @ # $ % & ! * )",
						value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%&!*])([a-zA-Z0-9@#$%&!*]{12,25})$/
					}}
					minLength={{
						message: "La longitud debe ser entre 12 y 25 caracteres",
						value: 12
					}}
					required
				/>
			</div>
			<div className="mb-4">
				<PasswordControl
					name="confirmacionNuevaClave"
					label="Confirma nueva contraseña"
					maxLength={25}
					formMethods={methods}
					compareTo={{
						fieldToCompare: "nuevaClave",
						message: "La nueva contraseña y la confirmación no coinciden, verifícalas e intenta de nuevo"
					}}
					required
				/>
			</div>
			<div className="col-12 text-center">
				<LightRoutingLink disabled={loading} className="me-5" to="/:segmento">Cancelar</LightRoutingLink>
				<PrimaryButton disabled={loading} onClick={methods.handleSubmit(onAccept)}>Guardar</PrimaryButton>
			</div>
		</form>
	);
};

export default CambiarClaveForm;